import { render, staticRenderFns } from "./ProjectLayout.vue?vue&type=template&id=1310e9b8&scoped=true&"
import script from "./ProjectLayout.vue?vue&type=script&lang=ts&"
export * from "./ProjectLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1310e9b8",
  null
  
)

export default component.exports